import type { SpacingValue } from '../../../common/sizing';

export const chassisVars = {
  slot: {
    /**
     * The slot's width across, and the pitch of a row of them.
     *
     * Set by the rail rather than by the glyph: three 10px indicator icons and a pixel either side
     * come to 32, where the 24px glyph asks for 28. Everything a slot draws is this wide — recess,
     * rail, caption row — so the number that decides how many icons fit also decides where every
     * glyph on the faceplate lands. See `SlotIndicators`.
     */
    width: 32,
    height: 36,
    diagram: 20,
    caption: 12,
    indicator: 12,
    indicatorIcon: 10,
    indicatorInset: 1,
    heightWithIndicators: 48,
    radius: 6,
  },

  unit: {
    /** The name pill's width across, which is `labelInset` either side of one `labelLine`. */
    label: 20,
    labelLine: 16,
    labelInset: 2,
  },

  gap: {
    slot: 8,
    column: 4,
    section: 8,
    unit: 16,
  },

  padding: 8,
  radius: 12,
} satisfies {
  slot: {
    width: SpacingValue;
    height: SpacingValue;
    diagram: SpacingValue;
    caption: SpacingValue;
    indicator: SpacingValue;
    indicatorIcon: SpacingValue;
    indicatorInset: SpacingValue;
    heightWithIndicators: SpacingValue;
    radius: SpacingValue;
  };
  unit: {
    label: SpacingValue;
    labelLine: SpacingValue;
    labelInset: SpacingValue;
  };
  gap: {
    slot: SpacingValue;
    column: SpacingValue;
    section: SpacingValue;
    unit: SpacingValue;
  };
  padding: SpacingValue;
  radius: SpacingValue;
};
